import { createReducer } from '@reduxjs/toolkit';

import {
  clearCompatibilityList,
  setCompatibilityList
} from '../../actions/vehicleCompatibility/vehicleCompatibilityList';

const initialState = {
  data: {},
};

const vehicleCompatibilityListReducer = createReducer(initialState, {
  [setCompatibilityList]: (state, { payload: data }) => ({
    ...state,
    data,
  }),
  [clearCompatibilityList]: (state,) => ({
    ...state,
    data: {}
  }),
});

export default vehicleCompatibilityListReducer;
